import { render, staticRenderFns } from "./BList.vue?vue&type=template&id=098f83fc&"
import script from "./BList.vue?vue&type=script&lang=js&"
export * from "./BList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports